import React, { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './NavigationLink.module.scss';

interface Props {
  icon(): ReactNode;
  text: string;
  link: string;
}

const NavigationLink: React.FC<Props> = ({ icon, text, link }) => {
  return (
    <NavLink
      to={link}
      className={({ isActive }) =>
        isActive ? `${styles.nav_link} ${styles.active_link}` : styles.nav_link
      }
    >
      <div className={styles.icon_wrapper}>{icon()}</div>
      <div className={styles.link_text}>{text}</div>
    </NavLink>
  );
};

export default NavigationLink;
